import Store from 'redux/store';
import {
  ADD_QUOTATION,
  ADD_QUOTATION_FAIL,
  ADD_QUOTATION_SUCCESS,
  ADD_QUOTATION_RESET,
} from 'redux/Reducers/Quotation/QuotationReducer';
import { redemptionEndpoint } from '../clients';

// eslint-disable-next-line default-param-last
export const AddQuotation = async (User, finallyCallback = () => { }, payload = {}) => {
  Store.dispatch({ type: ADD_QUOTATION });
  redemptionEndpoint(User).post(`/Quote`, payload).then((response) => {
    Store.dispatch({
      type: ADD_QUOTATION_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: ADD_QUOTATION_FAIL, error: e,
    });
  })
    .finally(() => {
      Store.dispatch({
        type: ADD_QUOTATION_RESET
      });

      finallyCallback();
    });
};

